<template>
    <div
        :class="{
            'l-header-main__search': true,
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <AutocompleteForm
                v-model="keyword"
                :autocomplete-url="autocompleteUrl"
                :is-form-visible="isFormVisible"
                :is-open="isOpen"
                :input-placeholder="inputPlaceholder"
                @show-form="showForm"
                @hide-form="hideForm"
                @hide-results="hideResults"
                @reset-matches="resetMatches"
                @searched="setMatches"
            />

            <AutocompleteResults
                v-if="isOpen"
                :matches="matches"
                :keyword="keyword"
                :totals="totals"
                :is-loading="isLoading"
                @hide-form="hideForm"
                @hide-results="hideResults"
            />
        </div>
    </div>
</template>

<script>
import { checkResolution } from "Functions/helpers";
import RshopAutocomplete from "FrontendComponents/Autocomplete";
import { showHeaderOverlay, hideHeaderOverlay } from "Functions/overlay";
import AutocompleteForm from "VueComponents/AutocompleteForm";

export default {
    components: {
        AutocompleteForm: AutocompleteForm,
        AutocompleteResults: () => import("./AutocompleteResults"),
    },
    extends: RshopAutocomplete,
    data() {
        return {
            isFormVisible: false,
            isLoading: false,
        };
    },
    computed: {
        inputPlaceholder() {
            return checkResolution("cxs")
                ? this.$t("Autocomplete.Header.placeholderMobile")
                : this.$t("Autocomplete.Header.placeholder");
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                showHeaderOverlay("autocomplete");
            } else {
                hideHeaderOverlay("autocomplete");
            }
        },
    },
    created() {
        if (typeof Event.on === "function") {
            Event.on("Autocomplete.showForm", (response) => {
                if (this.isFormVisible) {
                    this.hideForm();
                } else {
                    this.showForm();
                }
            });
        }
    },
    methods: {
        showForm() {
            this.isFormVisible = true;

            if (this.matches.count) {
                this.showResults();
            }
        },
        hideForm() {
            this.isFormVisible = false;
        },
        showResults() {
            this.isOpen = true;
        },
        hideResults() {
            this.isOpen = false;
        },
        resetMatches() {
            this.matches = {};
        },
        handleClickOutside($event) {
            if (
                !this.$el.contains($event.target) &&
                (this.isOpen || this.isFormVisible) &&
                !$event.target.parentNode.classList.contains("js-trigger-search") &&
                !$event.target.classList.contains("js-trigger-search") &&
                !$event.target.closest(".swal2-container")
            ) {
                this.isOpen = false;
                this.isFormVisible = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.Event.dispatch === "function") {
                    window.Event.dispatch("Autocomplete.hide");
                }
            }
        },
    },
};
</script>
